<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      line-form
      show-save-button
      unit="收入名称"
      edit-title
      id-key="IncomeId"
      :data="data"
      form-label-width="120px"
      @create-opened="onCreateOpened"
      @opened="$refs.typeSelect.init()"
      @closed="$refs.typeSelect.clear()"
      :form-rules="rules"
      :save-func="api.save"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="收入类别" prop="ClassId">
          <type-select ref="typeSelect" v-model="data.ClassId" />
        </el-form-item>
        <el-form-item label="收入编码" prop="IncomeNo">
         <span v-if="Mode==0" class="detail-span">{{data.IncomeNo}}</span>
          <el-input v-else v-model="data.IncomeNo" placeholder="请输入收入编号"></el-input>
        </el-form-item>
        <el-form-item label="收入名称" prop="IncomeName">
          <el-input v-model="data.IncomeName" placeholder="请输入收入名称" />
        </el-form-item>
        <el-form-item label="默认票据类型" prop="InvoiceType">
          <invoice-select  v-model="data.InvoiceType" :clearable="false" />
        </el-form-item>
         <el-form-item label="收入项目" prop="ItemName">
              <item-select  v-model="data.ItemName" init @select="select" />
        </el-form-item>
        <el-form-item label="关联单据类型" prop="SourceTypeId">
          <source-select  v-model="data.SourceTypeId" :clearable="false" />
        </el-form-item>
        <el-form-item label="序号" prop="Sn">
          <el-input v-model="data.Sn" v-int style="width: 100px;" />
          <span class="t-tips">*值越小排得越前</span>
        </el-form-item>
        <el-form-item label="状态" prop="Status">
          <el-radio-group v-model="data.Status" class="detail-span">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import typeSelect from "./type/select";
import invoiceSelect from "@/components/basedata/finance/invoice/select"
import itemSelect from "@/components/basedata/finance/incomeitems/select"
import sourceSelect from "@/components/basedata/basedoc/billtype/select"

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    typeSelect,
    invoiceSelect,
    itemSelect,
    sourceSelect
  },
  data() {
    return {
      data: {
        InvoiceType: "",
        InvoiceTypeName: "",
        IncomeId: 0,
        IncomeNo: "",
        IncomeName: "",
        ClassId: 0,
        ClassName: "",
        Sn: 0,
        Status: 1,
        ItemId: "",
        ItemName: "",
        SourceTypeId: "",
      },
      api: require("@/api/ba/income").default,
      code_api: require("@/api/sy/serialCode").default,
      Mode: 0,
      rules: {
        IncomeNo: [{ required: true, message: "收入编码不能为空" }],
        IncomeName: [{ required: true, message: "收入名称不能为空" }],
        ClassId: [{ required: true, message: "请选择收入类别" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened() {
      this.api.getMaxSn(this.data.ClassId||0).then((res) => {
        this.data.Sn = res;
      });

      this.code_api.previewNo("收入").then((res) => {
        console.log("serialType", res);
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.IncomeNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取收入编号失败");
        }
      });
    },
    select(data){
      this.data.ItemId = data.ItemId;
    },
  },
};
</script>